/**
 * Which file or creation the one share dialog shows (ShareDialogHost, mounted once in
 * AppShell). Every surface opens it with an id and a name; the server knows the rest.
 */
import { create } from "zustand";

export interface ShareTarget {
  id: string;
  name: string;
  mimeType?: string | null;
  sizeBytes?: number | null;
  where: "Files" | "Creations";
}

interface ShareDialogStore {
  target: ShareTarget | null;
  open: (target: ShareTarget) => void;
  close: () => void;
}

export const useShareDialogStore = create<ShareDialogStore>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));
